import { DynamicFormV2Palette } from "@mui/material";

export type FormDatePickerFieldComponentTokenType = {
  textColor: string;
  placeholderColor: string;
  backgroundColor: string;
  borderColor: string;
  hoverBorderColor: string;
  errorBorderColor: string;
  popoverBackgroundColor: string;
  headerTextColor: string;
  dayOfWeekTextColor: string;
  todayBorderColor: string;
  dayTextColor: string;
  dayHoverBackgroundColor: string;
  dayHoverTextColor: string;
  selectedDayTextColor: string;
  selectedDayBackgroundColor: string;
};

export const assignDatePickerFieldComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark",
  isDullMode: boolean
) => {
  const isLightMode = mode === "light";

  return {
    textColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    placeholderColor: formsPalette.text.supershy,
    backgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
    borderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.intense,
    hoverBorderColor: formsPalette.border.brand,
    errorBorderColor: formsPalette.border.error,
    popoverBackgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
    headerTextColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    dayOfWeekTextColor: formsPalette.text.supershy,
    todayBorderColor: formsPalette.border.supershy,
    dayTextColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    dayHoverTextColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    dayHoverBackgroundColor: isLightMode
      ? isDullMode
        ? formsPalette.surface.quiet
        : formsPalette.surface.supershy
      : formsPalette.surface.quiet,
    selectedDayTextColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.reverse,
    selectedDayBackgroundColor: isLightMode
      ? isDullMode
        ? formsPalette.surface.moderate
        : formsPalette.surface.quiet
      : formsPalette.surface.reverse,
  } as FormDatePickerFieldComponentTokenType;
};
